import { is } from 'ramda';

import { ApiUtils } from './utils';

/**
 * @public
 */
export abstract class ParamsAdapter {
  /**
   * Transform params to Object
   */
  toObject(isMidBack: boolean = false): unknown {
    return this.transform(this.getParams(), isMidBack);
  }

  /**
   * Transform params to FormData
   */
  toFormData(isMidBack: boolean = false): FormData {
    return this.buildFormData(this.transform(this.getParams(), isMidBack));
  }

  private transform(obj, isMidBack = false): unknown {
    const params = {};

    if (isMidBack && obj.constructor === Array) {
      return obj;
    }
    Object.keys(obj)
      .filter((key) => obj[key] !== null && obj[key] !== undefined)
      .forEach((key: string) => {
        let param = obj[key];
        if (is(Object, obj[key]) && obj[key].constructor === Object) {
          param = this.transform(obj[key], isMidBack);
        }
        if (isMidBack) {
          params[ApiUtils.toCamelCase(key)] = ApiUtils.convert(param, true);
        } else {
          params[ApiUtils.toUnderscoreCase(key)] = ApiUtils.convert(param);
        }
      });

    return params;
  }

  private buildFormData(obj: unknown): FormData {
    const formData = new FormData();
    Object.keys(obj).forEach((key: string) => {
      // Array are stringify except for File[]
      if (obj[key] instanceof Array) {
        for (const file of obj[key]) {
          formData.append(key, file);
        }
      } else {
        formData.append(key, obj[key]);
      }
    });

    return formData;
  }
  /**
   *
   * @returns object formatted as API requires
   */
  abstract getParams(): unknown;
}
